import {
  DataDeclarationIcaro,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { DateTime } from 'luxon';
import { formatNameIcaro, formatSurnameIcaro } from '../format-surname-name-icaro';

export const transformerMother = (data: DataDeclarationIcaro): SubjectIcaroVM | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    freshman: data.matricolaMadre?.toString() || '',
    numberFamily: data.numeroFamigliaMadre?.toString() || '',
    surname: formatSurnameIcaro(data.cognomeNomeMadre),
    name: formatNameIcaro(data.cognomeNomeMadre),
    dateBorn: data.dataNascitaMadre ? DateTime.fromFormat(data.dataNascitaMadre, 'yyyyMMdd') : null,
    municipalityBorn: `${data.comuneNascitaMadreDescrizione || ''} ${
      data.provNascitaMadreDescrizione ? `(${data.provNascitaMadreDescrizione})` : ''
    }`,
    municipalityResidence: `${data.comuneResidenzaMadreDescrizione || ''} ${
      data.provResidenzaMadreDescrizione ? `(${data.provResidenzaMadreDescrizione})` : ''
    }`,
  };
};
